// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum SimulationBankState {
  /**
   * Waiting for VTS to connect through the tunnel.
   */
  WAITING = 0,

  /**
   * VTS is connected and traffic is flowing.
   */
  CONNECTED = 1,

  /**
   * A non-looping replay reached its end.
   */
  FINISHED = 2,
  FAILED = 3,

  /**
   * The bank is disabled in the scenario.
   */
  DISABLED = 4,
}
